<app-header [showDate]="true" class="timeapp"></app-header>

<router-outlet></router-outlet>
